export default __webpack_public_path__ + "static/media/projectRibbon.eae0741c.svg";